module.exports = __webpack_public_path__ + "img/7.c80cfe40.jpg";